import React, { createContext } from "react";

export type DesignName = "primary" | "marketing";

export interface IDesignContext {
   name: DesignName
}
export const DesignContext = createContext<IDesignContext>({
   name: "marketing"
});

export interface IDesignContextProviderProps extends React.HTMLAttributes<HTMLDivElement> {
   name: DesignName
}

export const DesignContextProvider: React.FC<IDesignContextProviderProps> = function ({ children, name, ...rest }) {
   return (<DesignContext.Provider value={{
      name
   }}>
      <div data-design={name} {...rest}>{children}</div>
   </DesignContext.Provider>);
}